/* global OfficeRuntime */

/**
 * Session management for storing and retrieving the auth token
 */

const TOKEN_KEY = "auth_token";
const USER_KEY = "auth_user";

export class Session {
  static async getToken(): Promise<string | null> {
    try {
      if (typeof OfficeRuntime !== "undefined" && OfficeRuntime.storage) {
        return await OfficeRuntime.storage.getItem(TOKEN_KEY);
      }
      return localStorage.getItem(TOKEN_KEY);
    } catch (error) {
      console.error("Error getting token from storage", error);
      return null;
    }
  }

  static async setToken(token: string): Promise<void> {
    try {
      if (typeof OfficeRuntime !== "undefined" && OfficeRuntime.storage) {
        await OfficeRuntime.storage.setItem(TOKEN_KEY, token);
      } else {
        localStorage.setItem(TOKEN_KEY, token);
      }
    } catch (error) {
      console.error("Error saving token to storage", error);
    }
  }

  static async getUser(): Promise<any | null> {
    try {
      let userStr: string | null = null;
      if (typeof OfficeRuntime !== "undefined" && OfficeRuntime.storage) {
        userStr = await OfficeRuntime.storage.getItem(USER_KEY);
      } else {
        userStr = localStorage.getItem(USER_KEY);
      }
      return userStr ? JSON.parse(userStr) : null;
    } catch (error) {
      console.error("Error getting user from storage", error);
      return null;
    }
  }

  static async setUser(user: any): Promise<void> {
    try {
      const userStr = JSON.stringify(user);
      if (typeof OfficeRuntime !== "undefined" && OfficeRuntime.storage) {
        await OfficeRuntime.storage.setItem(USER_KEY, userStr);
      } else {
        localStorage.setItem(USER_KEY, userStr);
      }
    } catch (error) {
      console.error("Error saving user to storage", error);
    }
  }

  static async clear(): Promise<void> {
    try {
      if (typeof OfficeRuntime !== "undefined" && OfficeRuntime.storage) {
        await OfficeRuntime.storage.removeItem(TOKEN_KEY);
        await OfficeRuntime.storage.removeItem(USER_KEY);
      } else {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(USER_KEY);
      }
    } catch (error) {
      console.error("Error clearing storage", error);
    }
  }

  static async isLoggedIn(): Promise<boolean> {
    const token = await this.getToken();
    return !!token;
  }
}
